import type { Transaction } from '@lira/shared';

export function isLogicalTransfer(transaction: Transaction): boolean {
  return transaction.type === 'transfer'
    && Boolean(transaction.transferGroupId)
    && Boolean(transaction.fromAccountId)
    && Boolean(transaction.toAccountId);
}

export function hasEffectuationSource(transaction: Transaction): boolean {
  return Boolean(transaction.accountId) || isLogicalTransfer(transaction);
}

export async function runEffectuationBatch(
  ids: string[],
  effectuate: (id: string) => Promise<unknown>,
): Promise<void> {
  const results = await Promise.allSettled(ids.map((id) => effectuate(id)));
  const failed = results.filter((result) => result.status === 'rejected').length;
  if (failed > 0) {
    const succeeded = results.length - failed;
    throw new Error(
      `${succeeded} operação(ões) efetivada(s); ${failed} falhou(aram). A lista foi atualizada.`,
    );
  }
}

export function effectuationSuccessMessage(type: Transaction['type']): string {
  if (type === 'transfer') return 'Transferência efetivada.';
  return type === 'income' ? 'Receita recebida.' : 'Despesa paga.';
}

export function transferRouteLabel(transaction: Transaction): string | null {
  if (transaction.fromAccountName && transaction.toAccountName) {
    return `${transaction.fromAccountName} → ${transaction.toAccountName}`;
  }
  return transaction.accountName;
}

export function transferAccountIds(transaction: Transaction): {
  fromAccountId: string | null;
  toAccountId: string | null;
} {
  if (transaction.fromAccountId || transaction.toAccountId) {
    return {
      fromAccountId: transaction.fromAccountId,
      toAccountId: transaction.toAccountId,
    };
  }
  return transaction.amountCents < 0
    ? { fromAccountId: transaction.accountId, toAccountId: null }
    : { fromAccountId: null, toAccountId: transaction.accountId };
}
